import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';

@Pipe({
  name: 'controlRequiredText'
})
export class ControlRequiredTextPipe implements PipeTransform {

  transform(control: UntypedFormControl): string {

    if (!control.validator)
      return '';

    const validator = control?.validator({} as AbstractControl);

    if (validator && validator.required) {
      return '(*)';
    }

    return '';
  }
}
